import type { ComposerTranslation } from 'vue-i18n'

export const StatusMap = {
  /** 未发现威胁 */
  notFound: 1,
  /** 白名单 */
  white: 2,
  /** 恶意 */
  malice: 3,
  /** 疑似 */
  suspected: 4,
  /** 未知 */
  unknow: 5,
}

export const StatusId = {
  /** 未发现威胁 */
  1: 'notFound',
  /** 白名单 */
  2: 'safe',
  /** 恶意 */
  3: 'threats',
  /** 疑似 */
  4: 'suspected',
  /** 未知 */
  5: 'unknow',
}

/** kscore 档位 → `parseStatus.*` 文案键 */
export const STATUS_TITLE_I18N_KEYS: Record<number, string> = {
  1: 'parseStatus.notFoundThreat',
  2: 'parseStatus.knownSafe',
  3: 'parseStatus.knownThreat',
  4: 'parseStatus.suspectedThreat',
  5: 'parseStatus.unknownInfo',
}

export const StatusColor = {
  /** 未发现威胁 */
  1: 'var(--cm-color-primary)',
  /** 白名单 */
  2: '#53c734',
  /** 恶意 */
  3: '#F44B44',
  /** 疑似 */
  4: '#FA931A',
  /** 默认 */
  0: '#949494',
  // 未知
  5: '#949494',
}

export const SeverityId = {
  /** 低危漏洞 */
  1: 'low',
  /** 中危漏洞 */
  2: 'middle',
  /** 高危漏洞 */
  3: 'high',
  /** 超危漏洞 */
  4: 'higher',
  /** 未知漏洞 */
  unknow: 'unknow'
}

export const SeverityColor = {
  /** 低危漏洞 */
  1: '#FA931A',
  /** 中危漏洞 */
  2: '#F46A37',
  /** 高危漏洞 */
  3: '#F44B44',
  /** 超危漏洞 */
  4: '#C3322C',
  /** 未知漏洞 */
  unknow: '#949494'
}

export function parseStatus (score: number | string): number {
  const kScore = Number(score)
  if (kScore === 0) {
    return StatusMap.unknow
  }

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (kScore >= 1 && kScore < 20) {
    return StatusMap.malice
  }

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (kScore >= 20 && kScore < 63) {
    return StatusMap.suspected
  }

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (kScore >= 63 && kScore < 88) {
    return StatusMap.notFound
  }

  // eslint-disable-next-line @typescript-eslint/no-magic-numbers
  if (kScore >= 88 && kScore <= 100) {
    return StatusMap.white
  }

  return StatusMap.unknow
}

export function getStatusTitle (score: number | string, t: ComposerTranslation): string {
  const id = parseStatus(score)
  const key = STATUS_TITLE_I18N_KEYS[id]
  return key ? t(key) : t(STATUS_TITLE_I18N_KEYS[5])
}

export function getStatusColor (score: number | string): string {
  return (StatusColor as any)[parseStatus(score)]
}
